// extracted by mini-css-extract-plugin
export default {"top-2-box-end-spacer":"Top2BoxEndSpacer_top-2-box-end-spacer__dt7BU"};